// pdfActionsMixin.js
import { downloadBlob, openBlobOnTab } from '../../../shared/download_blob';
import * as toastr from 'toastr';
import axios from 'axios';

export const pdfActionsMixin = {
  methods: {
    async handlePdfAction(event, docType, actionType) {
      const btn = event.currentTarget;
      btn.disabled = true;
      const endpointMap = {
        resume: 'fetch_resume',
        pastCareer: 'fetch_past_career',
      };
      const endpoint = endpointMap[docType];
      const successHandler =
        actionType === 'download' ? downloadBlob : openBlobOnTab;
      try {
        const response = await axios.get(`/api/v2/applicants/${endpoint}`, {
          responseType: 'blob',
        });
        successHandler(response);
      } catch (error) {
        toastr.error('エラーが発生しました。');
        console.error(error);
      } finally {
        btn.disabled = false;
      }
    },
    downloadResume(event) {
      this.handlePdfAction(event, 'resume', 'download');
    },
    previewResume(event) {
      this.handlePdfAction(event, 'resume', 'preview');
    },
    downloadPastCareer(event) {
      this.handlePdfAction(event, 'pastCareer', 'download');
    },
    previewPastCareer(event) {
      this.handlePdfAction(event, 'pastCareer', 'preview');
    },
  },
};
